import {Component, Input, OnInit} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {Statut} from "@domain/workflow/statut";
import {RelanceDetail} from "@domain/relance/relance-detail";

/**
 * Item de la liste des statuts (Relance)
 */
@Component({
    host: {'data-test-id': 'statut-relance-list-item'},
    templateUrl: './statut-relance-list-item.component.html'
})
export class StatutRelanceListItemComponent extends ListViewItem<Statut> implements OnInit {

    //Relance courante
    @Input() extraOptions: { relance: RelanceDetail };

    ngOnInit(): void {
        //Initialisation de isSelected
        const ids = (this.extraOptions?.relance?.listeStatut ?? []).map(s => s.idStatut);
        this.data.isSelected = ids.includes(this.data.idStatut);
    }
}